import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CapitalSocialSnapshot,
  SocioSnapshot,
} from '../../models/constitution-snapshot.model';
import {
  buildGroupedShareSeries,
  buildSeriesParticipationTotals,
  formatEuro,
  formatEuroInteger,
  formatPct4,
  partnerTotalAdjustedShares,
} from '../../../constitution-form/utils/socios-display.util';
import { formatShareAmountEs } from '../../../constitution-form/utils/format-share-amount';
import { formatTituloLabel } from '../../../constitution-form/utils/titulo-label.util';
import { formatYesNo } from '../../../constitution-form/utils/admin-display.util';
import { ConstitutionReadonlyFieldComponent } from '../shared/constitution-readonly-field.component';

@Component({
  selector: 'app-constitution-socios-readonly-detail',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ConstitutionReadonlyFieldComponent],
  templateUrl: './constitution-socios-readonly-detail.component.html',
  styleUrl: '../../../constitution-form/constitution-form.component.scss',
})
export class ConstitutionSociosReadonlyDetailComponent {
  socio = input.required<SocioSnapshot>();
  capital = input.required<CapitalSocialSnapshot>();

  readonly formatShareAmount = formatShareAmountEs;
  readonly formatEuro = formatEuro;
  readonly formatYesNo = formatYesNo;
  readonly tituloLabel = formatTituloLabel;
  readonly formatPct4 = formatPct4;

  readonly groupedShares = computed(() =>
    buildGroupedShareSeries(this.socio().shareNumberings ?? [], this.capital()),
  );

  readonly seriesTotals = computed(() => buildSeriesParticipationTotals(this.groupedShares()));

  readonly modalTotalAccionesAjustadas = computed(() =>
    partnerTotalAdjustedShares(this.socio().shareNumberings ?? []),
  );

  monthlyIncomeLabel(): string {
    return formatEuroInteger(this.socio().rendimientoNetoMensual);
  }

  formatAdjusted(value: number): string {
    return formatShareAmountEs(value, 4);
  }
}
